import { useEffect } from "react";

import FeatureGates from "@atlaskit/feature-gate-js-client";
import { MeResponse, ProductKeys } from "@atlassiansox/asc-stargate";

import { CrossFlowTouchpointProvider } from "@/components/cross-flow/touchpoint";
import { AvailableProductsResponse } from "@/libraries/bxp-web-stargate-client/src";
import { IntercomProvider } from "@/libraries/intercom/src";
import { ConfluenceSoftwarePageTemplate } from "@/templates/software/confluence/confluence-software-page/src";
import { experiments, useExperimentExposure } from "@/utils/experiment";
import {
    JourneyLocalStoragePersona,
    useAnchorLocalStorage
} from "@/utils/local-storage-hook.tsx";

import { AppPricingData } from "../../../../contentful";

import { isTargetedSubAnchor } from "./subAnchors/subAnchor-util.tsx";

export type ConfluenceSoftwarePageProps = {
    pricing?: AppPricingData;
    availableProducts: AvailableProductsResponse | null;
    userProfile: MeResponse | null;
    keyword?: string;
    subAnchor?: string;
};

export const ConfluenceSoftwarePage = (props: ConfluenceSoftwarePageProps) => {
    // FYI, this is currently JA only, since we only have JA work space appId
    const isBootIntercom: boolean = FeatureGates.checkGate(
        "gwp-737-enable-intercom-chat-confluence"
    );
    const [exposureSubAnchorFired, fireSubAnchorExposure] =
        useExperimentExposure(experiments.cfind3254LandingPageSubAnchor);
    useEffect(() => {
        if (isTargetedSubAnchor(props.subAnchor) && !exposureSubAnchorFired) {
            fireSubAnchorExposure();
        }
    }, [exposureSubAnchorFired, fireSubAnchorExposure]);

    const { setAnchorLocalStorage } = useAnchorLocalStorage();
    useEffect(() => {
        const { keyword, subAnchor } = props;
        const anchorLocalStorage: JourneyLocalStoragePersona = {};
        if (!!keyword) {
            anchorLocalStorage.keyword = keyword;
        }
        if (!!subAnchor) {
            anchorLocalStorage.subAnchor = subAnchor;
        }
        if (Object.keys(anchorLocalStorage).length > 0) {
            setAnchorLocalStorage(anchorLocalStorage);
        }
    }, [props.keyword]);

    return (
        <IntercomProvider appId={"p0ww63i2"} triggerBoot={isBootIntercom}>
            <CrossFlowTouchpointProvider
                screenName="wacConfluenceProductTourPage"
                productKeys={[ProductKeys.CONFLUENCE]}
            >
                <ConfluenceSoftwarePageTemplate
                    pricing={props.pricing}
                    availableProducts={props.availableProducts}
                    userProfile={props.userProfile}
                    keyword={props.keyword}
                />
            </CrossFlowTouchpointProvider>
        </IntercomProvider>
    );
};
